import { useShallow } from "zustand/react/shallow";
import { OrderSummary as OrderSummaryUI } from "@codway-dev/ui";
import { useEditorStore, ComponentSettings } from "../../../store";

interface OrderSummaryPreviewProps {
  label?: string;
}

const DUMMY_PRODUCTS = [
  {
    title: "Premium T-Shirt",
    price: "2500",
    quantity: 1,
  },
  {
    title: "Designer Jeans",
    price: "7500",
    quantity: 1,
  },
];

export function OrderSummary({ label }: OrderSummaryPreviewProps) {
  const componentStyles = useEditorStore(
    useShallow(
      (state): NonNullable<ComponentSettings["order_summary"]> =>
        state.config.design.settings.components?.order_summary ?? {}
    )
  );

  return (
    <OrderSummaryUI
      products={DUMMY_PRODUCTS}
      currency="USD"
      title={label}
      subtotalLabel={componentStyles.subtotal_text}
      shippingLabel={componentStyles.shipping_text}
      totalLabel={componentStyles.total_text}
      showTaxNotice={componentStyles.show_tax_notice}
      backgroundColor={componentStyles.background_color}
      borderWidth={componentStyles.border_width}
    />
  );
}
